import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import Pm10030View from "../../Views/Purchase/PM10030";
import Snackbar from "../../Components/Snackbar";

function PM10030(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [inputs, setInputs] = React.useState({
    custNm: "",
    custCd: "",
    stockInNo: "",
    stockInDt: new Date(),
    createId: "",
    inWh: "",
    poStusNm: "",
    poNo: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [rowData1, setRowData1] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [stockInDt, setStockInDt] = React.useState(new Date());
  const [selectedRadio, setSelectedRadio] = React.useState("All");
  const [savePoNo, setSavePoNo] = React.useState("");
  const [saveLotNo, setSaveLotNo] = React.useState("");
  const today = new Date();
  const monthAgo = new Date(today);
  const [startDate, setStartDate] = React.useState(
    monthAgo.setMonth(today.getMonth() - 3)
  );
  const [endDate, setEndDate] = React.useState(new Date());
  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    SearchLogic();
  }, []);

  const SearchLogic = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Purchase.PM10030.GetPurchaseOrderMst,
        {
          startDate: new Date(startDate),
          endDate: new Date(endDate),
          type: selectedRadio,
        }
      ).then((result) => {
        let data = result.data;

        if (data === "데이터가 없습니다.") {
          if (lanData[0] != null) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: getLanData.filter(
                (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
              )[0].lanName,
            });
            setRowData([]);
          }
        } else if (data.type === "데이터가 없습니다.") {
          if (lanData[0] != null) {
            setSnackbars({
              toggle: true,
              type: "info",
              message: getLanData.filter(
                (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              plantCd: data[i].plantCd,
              poStusCd: data[i].poStusCd,
              poStusNm: data[i].poStusNm,
              poCreateDt: data[i].poCreateDt
                ? Commons.DateFormating(data[i].poCreateDt.toString(), 2)
                : "",
              stockInNo: data[i].stockInNo,
              stockInDt: new Date(data[i].stockInDt),
              poNo: data[i].poNo,
              custCd: data[i].custCd,
              custNm: data[i].custNm,
              personCharg: data[i].personCharg,
              reference: data[i].reference,
              inWh: data[i].inWh,
            });
          }
          setRowData(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SearchItemLogic = async (_pono, _stockInNo) => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    setSavePoNo(_pono);
    setSaveLotNo(_stockInNo);
    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Purchase.PM10030.GetPurchaseOrderDtl,
        {
          poNo: _pono,
          stockInNo: _stockInNo ? _stockInNo : "string",
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setRowData1([]);
        } else if (data.type === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setRowData1([]);
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              stockInNo: data[i].stockInNo,
              poStusNm: data[i].poStusNm,
              stockInDt: data[i].stockInDt
                ? new Date(data[i].stockInDt)
                : new Date(),
              plantCd: data[i].plantCd,
              poCreateDt: data[i].poCreateDt
                ? Commons.DateFormating(data[i].poCreateDt.toString(), 2)
                : "",
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              whNm: data[i].whNm,
              itemStd: data[i].itemStd,
              poItemQty: data[i].poItemQty,
              poAddItemQty: data[i].poAddItemQty,
              inQty: data[i].inQty,
              itemUnit: data[i].itemUnit,
              itemVatYn: data[i].itemVatYn,
              inItemCost: data[i].inItemCost,
              inItemAmt: data[i].inItemAmt
                ? data[i].inItemAmt
                : data[i].inQty * data[i].poItemCost,
              inItemVat: data[i].inItemVat,
              remark: data[i].remark,
              poItemCost: data[i].poItemCost,
              lotNo: data[i].lotNo,
              createId: data[i].createId,
              createDate: data[i].createDate,
              updateId: data[i].updateId,
              updateDate: data[i].updateDate,
            });
          }
          setRowData1(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SaveConfirm = (_type) => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        SaveLogic();
      }
    );
  };

  const SaveLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;
    let updateData = changedRowData.reverse().reduce((prev, now) => {
      if (!prev.some((obj) => obj.itemCd === now.itemCd)) {
        prev.push(now);
      }
      return prev;
    }, []);
    let getData = [];

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      for (let i = 0; i < updateData.length; i++) {
        getData.push({
          plantCd: updateData[i].plantCd,
          stockInNo: updateData[i].stockInNo
            ? "string"
            : updateData[i].stockInNo,
          itemCd: updateData[i].itemCd,
          custCd: inputs.custCd,
          poNo: inputs.poNo,
          stockInDt: Commons.DateStrChange(new Date(updateData[i].stockInDt)),
          inWh: inputs.inWh,
          inQty: updateData[i].inQty * 1,
          inItemCost: updateData[i].inItemCost * 1,
          inItemAmt: updateData[i].inQty * updateData[i].inItemCost,
          inItemVat: updateData[i].inQty * updateData[i].inItemCost * 0.1,
          currencyCd: "string",
          poStusNm: updateData[i].poStusNm,
          lotNo: updateData[i].lotNo,
          remark: updateData[i].remark,
          createId: userInfo.userId,
          createDate: Commons.DateStrChange(new Date()),
          updateId: userInfo.userId,
          updateDate: Commons.DateStrChange(new Date()),
        });
      }
      if (updateData == undefined || updateData == null || updateData == "") {
        // setSnackbars({
        //   toggle: true,
        //   type: "info",
        //   message: "",
        // });
      } else {
        if (getData[0].poStusNm != "입고완료") {
          await Commons.Axios(
            "post1",
            Global.serverUrls.useUrl +
              Global.urls.logic.Purchase.PM10030.CreatePurchaseStockIn,
            getData
          ).then((result) => {
            console.log(result);
            let data = result.data;
            if (data !== "Ok") {
              setSnackbars({
                toggle: true,
                typ: "error",
                message: data,
              });
              setChangedRowData([]);
            } else {
              setSnackbars({
                toggle: true,
                type: "success",
                message: lanData.filter(
                  (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
                )[0].lanName,
              });
              setChangedRowData([]);
              SearchLogic();
              SearchItemLogic(inputs.poNo, inputs.stockInNo);
            }
          });
        } else {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) =>
                f.lanId === "Dia_CompletedWarehousing" && f.lanType === "DIALOG"
            )[0].lanName,
          });
          setChangedRowData([]);
        }
      }
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      setChangedRowData([]);
      Dialog.ProgressBar(false);
    }
  };

  const DeleteConfirm = (_type) => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        DeleteLogic();
      }
    );
  };

  const DeleteLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];
    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      for (let i = 0; i < selectedRowData.length; i++) {
        deleteData.push({
          plantCd: selectedRowData[i].plantCd,
          stockInNo: selectedRowData[i].stockInNo,
          itemCd: selectedRowData[i].itemCd,
          poNo: savePoNo,
          lotNo: selectedRowData[i].lotNo,
          inQty: selectedRowData[i].inQty,
        });
      }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Purchase.PM10030.DeletePurchaseStockIn,
        deleteData
      ).then((result) => {
        let data = result.data;
        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else {
          SearchLogic();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
            )[0].lanName,
          });
          SearchItemLogic(inputs.poNo, inputs.stockInNo);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const Reset = () => {
    setInputs({
      ...inputs,
      custNm: "",
      custCd: "",
      stockInNo: "",
      stockInDt: new Date(),
      createId: "",
      inWh: "",
      poStusNm: "",
      poNo: "",
    });
  };

  return (
    <>
      <Pm10030View
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        rowData1={rowData1}
        setRowData1={setRowData1}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        setSelectedRowData={setSelectedRowData}
        selectedRowData={selectedRowData}
        inputs={inputs}
        setInputs={setInputs}
        stockInDt={stockInDt}
        setStockInDt={setStockInDt}
        selectedRadio={selectedRadio}
        setSelectedRadio={setSelectedRadio}
        SearchLogic={SearchLogic}
        SearchItemLogic={SearchItemLogic}
        SaveConfirm={SaveConfirm}
        DeleteConfirm={DeleteConfirm}
        Reset={Reset}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default PM10030;
